var map = {
	"./1.svg": 43100,
	"./2.svg": 22127,
	"./3.svg": 59550,
	"./4.svg": 84833,
	"./5.svg": 72592,
	"./6.svg": 17731,
	"./7.svg": 79794,
	"./8.svg": 3285,
	"./9.svg": 61300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11703;